import React from 'react';
import PropTypes from 'prop-types';
import { FlexBox, Span, Typography } from '@vp/swan';
import { useTranslations } from '@vp/om-translations';
import { get } from 'lodash';
import { DISPLAY_NAME, DISPLAY_VALUE } from '../../../constants/itemAccessors';

const UnpricedItemOption = ({ option }) => {
  const [lineItemMessages] = useTranslations(['lineItemMessages']);
  const optionDisplayName = get(option, DISPLAY_NAME);
  const optionDisplayValue = get(option, DISPLAY_VALUE);

  return (
    <FlexBox justifyContent="space-between">
      <Typography component="label" textColor="subtle">
        <div>
          {optionDisplayName}: {optionDisplayValue}
        </div>
      </Typography>
      <Span>{lineItemMessages.included}</Span>
    </FlexBox>
  );
};

UnpricedItemOption.propTypes = {
  option: PropTypes.object,
};

export default UnpricedItemOption;
